import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Dialog, Select, SelectOption, TextField } from '@wayste/sour-ui';
import { GooglePlacesInput } from '../../places-input';
const RadiusFromAddressModal = ({ open, googleMapsApiKey, onCancel, onSubmit, }) => {
    const [coordinates, setCoordinates] = React.useState(null);
    const [radius, setRadius] = React.useState('0');
    const [mode, setMode] = React.useState('draw');
    const unit = 'miles';
    return (_jsx(Dialog, { open: open, className: "max-w-3xl", onClose: onCancel, styledTitle: "Radius From Address", showX: true, children: _jsxs("div", { className: "flex w-full flex-col gap-4", children: [_jsx(GooglePlacesInput, { inputProps: {
                        label: 'Address',
                    }, showFullAddressInInput: true, onPlaceSelected: (place) => {
                        if (!place.coordinates.lat || !place.coordinates.lng) {
                            console.error('No coordinates found for place', place);
                            setCoordinates(null);
                            return;
                        }
                        setCoordinates({
                            lat: place.coordinates.lat,
                            lng: place.coordinates.lng,
                        });
                    }, apiKey: googleMapsApiKey }), _jsx(TextField, { label: "Distance", endAdornment: "miles", inputProps: {
                        value: radius,
                        onChange: (e) => {
                            // allow only one decimal
                            if (e.target.value.match(/^(\d*)\.{0,1}(\d){0,1}$/)) {
                                setRadius(e.target.value);
                            }
                            else if (e.target.value.match(/^[0-9]*$/)) {
                                setRadius(e.target.value);
                            }
                        },
                    } }), _jsxs(Select, { value: mode || undefined, onSelect: (value) => setMode(value), label: "Mode", children: [_jsx(SelectOption, { value: "draw", children: "Add" }), _jsx(SelectOption, { value: "cut", disabled: true, children: "Cut" })] }), _jsx("p", { children: "Enter an address and a radius to create a circular pricing zone. You can also use the map to create a circular pricing zone. When the mode is set to add it will add the circle to the pricing zone. When the mode is set to remove it will remove the circle from any overlapping zones. This can be useful for creating \"donut\" pricing." }), _jsxs("div", { className: "mt-2 flex justify-end gap-4", children: [_jsx("button", { className: "btn-dark-grey-outlined", onClick: onCancel, type: "button", children: "Cancel" }), _jsx("button", { className: "btn-primary", disabled: !coordinates || !radius, type: "button", onClick: () => {
                                if (coordinates?.lat && coordinates.lng && radius) {
                                    onSubmit({
                                        coordinates: coordinates,
                                        radius: parseFloat(radius),
                                        unit,
                                        mode,
                                    });
                                    return;
                                }
                                throw new Error('Coordinates and radius are required');
                            }, children: "Save" })] })] }) }));
};
export default RadiusFromAddressModal;
//# sourceMappingURL=RadiusFromAddressModal.js.map